/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Full_Stack_Web_Apps_Harden_Detail6Inputs */

const en_svc_full_stack_web_apps_harden_detail6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deploy, monitor, and hand over with docs and a runbook.`)
};

const ar_svc_full_stack_web_apps_harden_detail6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انشر وراقب وسلّم مع التوثيق ودليل تشغيل.`)
};

const bn_svc_full_stack_web_apps_harden_detail6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ডিপ্লয়, মনিটর এবং ডক ও রানবুকসহ হ্যান্ড ওভার করুন।`)
};

const de_svc_full_stack_web_apps_harden_detail6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereitstellen, Überwachen und Übergeben mit Dokumenten und einem Runbook.`)
};

const es_svc_full_stack_web_apps_harden_detail6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desplegar, monitorear y entregar con documentos y un runbook.`)
};

const fr_svc_full_stack_web_apps_harden_detail6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déployez, supervisez et faites la passation avec docs et runbook.`)
};

const pt_svc_full_stack_web_apps_harden_detail6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Implante, monitore e entregue com documentos e um runbook.`)
};

const zh_svc_full_stack_web_apps_harden_detail6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用文档和运行手册进行部署、监控和移交。`)
};

const tr_svc_full_stack_web_apps_harden_detail6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokümanlar ve runbook ile dağıtın, izleyin ve teslim edin.`)
};

const ru_svc_full_stack_web_apps_harden_detail6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Развертывание, мониторинг и передача с помощью документации и Runbook.`)
};

const pl_svc_full_stack_web_apps_harden_detail6 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wdrażaj, monitoruj i przekazuj z dokami i runbookiem.`)
};

/**
* | output |
* | --- |
* | "Deploy, monitor, and hand over with docs and a runbook." |
*
* @param {Svc_Full_Stack_Web_Apps_Harden_Detail6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_full_stack_web_apps_harden_detail6 = /** @type {((inputs?: Svc_Full_Stack_Web_Apps_Harden_Detail6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Full_Stack_Web_Apps_Harden_Detail6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_full_stack_web_apps_harden_detail6(inputs)
	if (locale === "bn") return bn_svc_full_stack_web_apps_harden_detail6(inputs)
	if (locale === "de") return de_svc_full_stack_web_apps_harden_detail6(inputs)
	if (locale === "es") return es_svc_full_stack_web_apps_harden_detail6(inputs)
	if (locale === "fr") return fr_svc_full_stack_web_apps_harden_detail6(inputs)
	if (locale === "pt") return pt_svc_full_stack_web_apps_harden_detail6(inputs)
	if (locale === "zh") return zh_svc_full_stack_web_apps_harden_detail6(inputs)
	if (locale === "tr") return tr_svc_full_stack_web_apps_harden_detail6(inputs)
	if (locale === "ru") return ru_svc_full_stack_web_apps_harden_detail6(inputs)
	if (locale === "pl") return pl_svc_full_stack_web_apps_harden_detail6(inputs)
	return en_svc_full_stack_web_apps_harden_detail6(inputs)
});
export { svc_full_stack_web_apps_harden_detail6 as "svc_full-stack-web-apps_HARDEN_detail" }